import getStateFromDOM from './getStateFromDOM';
export default getStateFromDOM;
